export default __webpack_public_path__ + "static/media/SourceHanSansCN-Medium.b1630234.otf";